var _a;
import { createSlice } from "@reduxjs/toolkit";
export var initialState = {
    toasts: [],
};
var toastReducer = createSlice({
    name: "toast",
    initialState: initialState,
    reducers: {
        addSuccessToast: function (state, _a) {
            var payload = _a.payload;
            state.toasts.push({ id: crypto.randomUUID(), type: "toast-success", message: payload });
        },
        addErrorToast: function (state, _a) {
            var payload = _a.payload;
            state.toasts.push({ id: crypto.randomUUID(), type: "toast-danger", message: payload });
        },
        resetToast: function (state) {
            state.toasts = [];
        },
    },
});
export var addSuccessToast = (_a = toastReducer.actions, _a.addSuccessToast), addErrorToast = _a.addErrorToast, resetToast = _a.resetToast;
export default toastReducer.reducer;
